<template>
  <div class="container page">
    <van-nav-bar :title="$t('withdraw.add_crypto_address')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main-box">
      <div class="label">{{$t("withdraw.add_crypto_tip")}}</div>
      <van-cell-group>
        <van-field v-model="crypto_type" :label="$t('withdraw.coin_type')" readonly :placeholder="$t('withdraw.coin_type')" @click="showSelectCoinType()"/>
        <van-field v-model="network" :label="$t('withdraw.network_type')" readonly :placeholder="$t('withdraw.select_network')" @click="showSelectNetwork()"/>
        <van-field v-model="address" :label="$t('withdraw.wallet_address')" :placeholder="$t('withdraw.wallet_address_tip')" />
      </van-cell-group>
      <p>{{$t("withdraw.crypto_warn")}}</p>
    </div>
    <van-button class="bindCard" type="default" @click="bindCryptoAddress()">{{$t("common.confirm")}}</van-button>
    <!-- 币种选择器 -->
    <van-popup v-model="showCoinTypePicker" round position="bottom" :style="{ height: '35%' }" >
      <van-picker
          show-toolbar
          :columns="coinTypes"
          :confirm-button-text="$t('common.confirm')"
          :cancel-button-text="$t('common.cancel')"
          @confirm="onCoinTypeConfirm"
          @cancel="onCoinTypeCancel"
      />
    </van-popup>

    <!-- 网络选择器 -->
    <van-popup v-model="showNetworkPicker" round position="bottom" :style="{ height: '35%' }" >
      <van-picker
          show-toolbar
          :columns="networks"
          :confirm-button-text="$t('common.confirm')"
          :cancel-button-text="$t('common.cancel')"
          @confirm="onNetworkConfirm"
          @cancel="onNetworkCancel"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      coinTypes: [
        { text: 'USDC', value: 'USDC' },
        { text: 'BTC', value: 'BTC' },
        { text: 'ETH', value: 'ETH' }
      ],
      // 不同币种对应的网络配置
      networkConfig: {
        'USDC': [
          { text: 'ERC20', value: 'ERC20' },
          { text: 'TRC20', value: 'TRC20' },
          { text: 'Solana', value: 'Solana' },
          { text: 'Polygon', value: 'Polygon' },
          { text: 'Arbitrum', value: 'Arbitrum' }
        ],
        'BTC': [
          { text: 'Bitcoin', value: 'Bitcoin' },
          { text: 'BTC (SegWit)', value: 'SegWit' },
          { text: 'Lightning Network', value: 'Lightning' }
        ],
        'ETH': [
          { text: 'ERC20', value: 'ERC20' },
          { text: 'Arbitrum', value: 'Arbitrum' },
          { text: 'Optimism', value: 'Optimism' },
          { text: 'Polygon', value: 'Polygon' },
          { text: 'zkSync', value: 'zkSync' }
        ]
      },
      networks: [],
      showCoinTypePicker: false,
      showNetworkPicker: false,
      userInfo: {},
      network: "",
      address: "",
      crypto_type: ""
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    bindCryptoAddress(){
      // 验证币种
      if(this.crypto_type === "" || this.crypto_type === null || this.crypto_type === undefined){
        this.$toast.fail(this.$t("withdraw.coin_type"));
        return false;
      }

      // 验证网络类型
      if(this.network === "" || this.network === null || this.network === undefined){
        this.$toast.fail(this.$t("withdraw.select_network"));
        return false;
      }

      // 验证钱包地址
      if(this.address === "" || this.address === null || this.address === undefined){
        this.$toast.fail(this.$t("withdraw.wallet_address_tip"));
        return false;
      }

      // 提交绑定请求
      this.$http({
        method: 'post',
        data: {
          address: this.address,
          crypto_type: this.crypto_type,
          network: this.network
        },
        url: 'user_set_crypto_address'
      }).then(res => {
        if(res.code === 200){
          this.$router.push({path: '/Withdraw'})
          this.$toast(res.msg);
        } else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    showSelectCoinType(){
      this.showCoinTypePicker = true;
    },
    showSelectNetwork(){
      // 如果还没选择币种，提示先选择币种
      if(!this.crypto_type) {
        this.$toast.fail(this.$t("withdraw.coin_type"));
        return;
      }
      this.showNetworkPicker = true;
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if(res.code === 200){
          this.userInfo = res.data;
        } else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    onCoinTypeConfirm(value) {
      this.crypto_type = value.text;
      // 根据币种更新可选网络列表
      this.networks = this.networkConfig[value.value] || [];
      // 清空之前选择的网络
      this.network = "";
      this.showCoinTypePicker = false;
    },
    onCoinTypeCancel() {
      this.showCoinTypePicker = false;
    },
    onNetworkConfirm(value) {
      this.network = value.text
      this.showNetworkPicker = false;
    },
    onNetworkCancel() {
      this.showNetworkPicker = false;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 32px;
  line-height: 80px;
}
.van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.bankbox{
  padding: 15px;
  color: #000;
  background-color: #fff;
}
.bankbox .title{
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}
.main-box{
  background: #fff;

}
.main-box .label{
  padding: 20px;
  font-size: 35px;
  color: #797878;
}
::v-deep .van-picker__toolbar {
  height: 100px;
}
::v-deep .van-picker__cancel, ::v-deep .van-picker__confirm {
  padding: 0 40px;
  font-size: 32px;
}
::v-deep .van-picker-column {
  font-size: 40px;
}
.main-box p{
  padding: 0 20px;
  font-size: 30px;
  color: #ee0a24;
}
.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#e6c3a1,#7e5678);
}
</style>
